// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606040149/js/" + chunkId + "." + {"44":"eb2eaefd","225":"c4d36a25","481":"9e212c0a","486":"196e62e5","770":"b1134573"}[chunkId] + ".0.9436272389959838.chunk.js";
};